export default __webpack_public_path__ + "static/media/titleZavvie.38c730be.webp";